module.exports = __webpack_public_path__ + "img/warning.ec9ad89b.png";